export const discoverySuggestionTags: string[] = [
  "Amber Ale",
  "Pale Ale",
  "Pilsner",
  "Helles",
  "Kolsch",
  "IPA",
  "NEIPA",
  "DIPA",
  "West Coast",
  "Table Beer",
  "Wheat Beer",
  "Sour",
  "Stout",
  "Porter",
  "Saison",
  "Barley Wine",
  "Weisse",
  "Tripel",
  "Bitter",
  "Blonde",
  "Golden",
  "Hazy",
  "Session",
  "Cider",
  "Soda",
  "Kombucha",
  "Seltzer",
  "Low Alcohol",
  "Barrel Aged",
  "Nitro",
  "Citra",
  "Mosaic",
  "Simcoe",
  "Cascade",
  "Cryo",
  "Sabro",
  "Mixed",
  "Sample",
];

export const randomizeDiscoverySuggestionTags = () => {
  return discoverySuggestionTags.sort(() => 0.5 - Math.random()).slice(0, 8);
};
